var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "table-wrapper" }, [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [_c("Spinner")], 1)
      : _vm._e(),
    _c("table", { staticClass: "data-table text-sm w-full font-outfit" }, [
      _c("thead", [
        _c(
          "tr",
          [
            _c(
              "th",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showSelect,
                    expression: "showSelect",
                  },
                ],
                staticClass:
                  "bg-lightBlue px-4 py-4 border-b-1 border-gray-200 text-left font-medium b-first_cell",
              },
              [
                _c("label", { staticClass: "custom-checkbox" }, [
                  _c("input", {
                    attrs: { type: "checkbox" },
                    domProps: { checked: _vm.areAllSelected },
                    on: {
                      change: function ($event) {
                        return _vm.selectAllRows($event)
                      },
                    },
                  }),
                  _c("span", { staticClass: "icon-checked" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "11",
                          height: "9",
                          viewBox: "0 0 11 9",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                            fill: "white",
                            stroke: "white",
                            "stroke-width": "0.3",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._l(_vm.columns, function (column) {
              return _c(
                "th",
                {
                  key: column.field,
                  staticClass:
                    "bg-lightBlue px-4 py-4 border-b-1 border-gray-200 text-left font-medium relative tb-header",
                },
                [
                  _vm._v(" " + _vm._s(column.label) + " "),
                  column.sort
                    ? _c("span", [
                        _c(
                          "span",
                          {
                            staticClass: "icon-sort",
                            on: {
                              click: function ($event) {
                                return _vm.sortColumn(column.field)
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "8",
                                  height: "12",
                                  viewBox: "0 0 8 12",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M7.94188 4.57036L4.21022 0.0960542C4.1034 -0.0320181 3.89773 -0.0320181 3.78978 0.0960542L0.0581151 4.57036C-0.0805157 4.7372 0.0444792 4.9816 0.268334 4.9816H7.73167C7.95552 4.9816 8.08052 4.7372 7.94188 4.57036Z",
                                    fill:
                                      _vm.sort_by === column.field &&
                                      _vm.sort_direction === "asc"
                                        ? "none"
                                        : "black",
                                    "fill-opacity": "0.25",
                                    stroke:
                                      _vm.sort_by === column.field &&
                                      _vm.sort_direction === "asc"
                                        ? "black"
                                        : "none",
                                    "stroke-width": "0.2",
                                    "stroke-opacity": "0.25",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M7.73167 7.0184H0.268334C0.0444792 7.0184 -0.0805157 7.2628 0.0581151 7.42964L3.78978 11.9039C3.89659 12.032 4.10227 12.032 4.21022 11.9039L7.94188 7.42964C8.08052 7.2628 7.95552 7.0184 7.73167 7.0184Z",
                                    fill:
                                      _vm.sort_by === column.field &&
                                      _vm.sort_direction === "desc"
                                        ? "none"
                                        : "black",
                                    "fill-opacity": "0.25",
                                    stroke:
                                      _vm.sort_by === column.field &&
                                      _vm.sort_direction === "desc"
                                        ? "black"
                                        : "none",
                                    "stroke-width": "0.2",
                                    "stroke-opacity": "0.25",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            }),
            _vm.hasActions
              ? _c("th", {
                  staticClass:
                    "bg-lightBlue px-4 py-4 border-b-1 border-gray-200 text-left font-medium",
                })
              : _vm._e(),
          ],
          2
        ),
      ]),
      _c(
        "tbody",
        [
          _vm._l(_vm.data, function (row) {
            return _c(
              "tr",
              { key: row.id, class: _vm.getBodyRowClasses?.(row) },
              [
                _c(
                  "td",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.showSelect,
                        expression: "showSelect",
                      },
                    ],
                    staticClass:
                      "px-4 py-4 border-b-1 border-gray-200 font-normal relative b-first_cell",
                  },
                  [
                    _c("label", { staticClass: "custom-checkbox" }, [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          value: row.id,
                          checked: _vm.selectedRows.includes(row.id),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.toggleSelection(row.id, row)
                          },
                        },
                      }),
                      _c("span", { staticClass: "icon-checked" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "11",
                              height: "9",
                              viewBox: "0 0 11 9",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M1.91308 4.03516H1.91326C1.99256 4.03525 2.07081 4.05331 2.14213 4.08798C2.21341 4.12262 2.27591 4.17295 2.32497 4.2352L1.91308 4.03516ZM1.91308 4.03516H1.09394C0.890308 4.03516 0.776602 4.26975 0.902321 4.4292L0.902371 4.42927L4.11214 8.49567L4.11218 8.49573C4.32247 8.76188 4.72568 8.76114 4.93667 8.49617L4.93708 8.49566L10.6597 1.24398C10.6598 1.24378 10.66 1.24358 10.6602 1.24338C10.7884 1.08295 10.6699 0.85 10.4689 0.85H9.6498C9.48941 0.85 9.33668 0.9235 9.2376 1.05044C9.23751 1.05055 9.23742 1.05066 9.23734 1.05077L4.52403 7.02157M1.91308 4.03516L4.52403 7.02157M4.52403 7.02157L2.32506 4.23531L4.52403 7.02157Z",
                                fill: "white",
                                stroke: "white",
                                "stroke-width": "0.3",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    row.is_new
                      ? _c("span", { staticClass: "red-dot" })
                      : _vm._e(),
                  ]
                ),
                _vm._l(_vm.columns, function (column) {
                  return _c(
                    "td",
                    {
                      key: column.field,
                      staticClass: "px-4 py-4 border-b-1 border-gray-200",
                    },
                    [
                      _vm._t(
                        column.field,
                        function () {
                          return [
                            column.field ===
                            "project_activity.project.client_name"
                              ? _c("span", [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "cursor-pointer hover:text-badgeBlue",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleProjectClick(row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getRowValue(row, column.field)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ])
                              : column.field === "project_activity.start_date"
                              ? _c("span", [
                                  _c("span", [
                                    _vm._v(" " + _vm._s(_vm.getDateValue(row))),
                                  ]),
                                ])
                              : _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getRowValue(row, column.field)
                                      ) +
                                      " "
                                  ),
                                ]),
                          ]
                        },
                        { row: row }
                      ),
                    ],
                    2
                  )
                }),
                _vm.hasActions
                  ? _c(
                      "td",
                      { staticClass: "px-4 py-4 border-b-1 border-gray-200" },
                      [_vm._t("actions", null, { row: row })],
                      2
                    )
                  : _vm._e(),
              ],
              2
            )
          }),
          !_vm.data.length
            ? _c("tr", [
                _c(
                  "td",
                  {
                    staticClass:
                      "px-4 py-4 border-b-1 border-gray-200 text-center text-gray-500",
                    attrs: {
                      colspan:
                        _vm.columns.length +
                        (_vm.showSelect ? 1 : 0) +
                        (_vm.hasActions ? 1 : 0),
                    },
                  },
                  [_vm._v(" No data available ")]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }